import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { EMPTY_OBJECT } from '../constants';
import { COMMON_LOGIN_STATE } from '../constants/loginStates.constants';
import LOGIN_TYPE from '../constants/loginType';
import STORAGE_KEY from '../constants/storageKey';
import URL from '../constants/urls';
import Loader from '../components/loader';

function getRedirectUrl(currentUrl) {
  const { pathname, search } = window.location || EMPTY_OBJECT;
  return `${currentUrl}?redirectTo=${encodeURIComponent(pathname + search)}`;
}

export const getUrlAndRedirect = (currentUrl) => {
  const redirectUrl = getRedirectUrl(currentUrl);
  window.location.href = redirectUrl;
};

export const getDefaultUrlBasedOnRoleAndState = (
  loggedInUserRole,
  state,
  isSpotOnMockInterview
) => {
  let navigateUrl = URL.LOGIN;
  const redirectUrl = JSON.parse(
    sessionStorage.getItem(STORAGE_KEY.REDIRECTION_URL)
  );
  if (loggedInUserRole === LOGIN_TYPE.UNIVERSITY) {
    navigateUrl = URL.UNIV_STUDENTS;
  } else if (loggedInUserRole === LOGIN_TYPE.CANDIDATE) {
    if (state === COMMON_LOGIN_STATE.INACTIVE) {
      if (isSpotOnMockInterview) {
        navigateUrl = URL.MOCK_INTERVIEW;
      } else {
        navigateUrl = URL.CANDIDATE_PROFILE;
      }
    } else if (redirectUrl) {
      navigateUrl = redirectUrl;
    } else {
      navigateUrl = URL.FIND_JOBS;
    }
  } else if (loggedInUserRole === LOGIN_TYPE.EMPLOYER) {
    if (state === COMMON_LOGIN_STATE.INACTIVE) {
      navigateUrl = URL.EMPLOYER_PROFILE;
    } else {
      navigateUrl = URL.FIND_CANDIDATES;
    }
  } else if (loggedInUserRole === LOGIN_TYPE.ADMIN) {
    navigateUrl = `${URL.ADMIN_ACTION}?action=site_map`;
  }

  return navigateUrl;
};

export const getDefaultHomeUrl = (loggedInUserRole) => {
  if (loggedInUserRole === LOGIN_TYPE.EMPLOYER) {
    return URL.FIND_CANDIDATES;
  }
  return URL.FIND_JOBS;
};

export default getRedirectUrl;


function ExternalRedirect({ to, replace = true, delay = 0 }) {
  useEffect(() => {
    const doRedirect = () => {
      if (replace) {
        window.location.replace(to);
      } else {
        window.location.href = to;
      }
    };

    if (delay > 0) {
      const timer = setTimeout(doRedirect, delay);
      return () => clearTimeout(timer);
    }
    doRedirect();
    return undefined;
  }, [to, replace, delay]);


  return delay > 0 ? <Loader /> : null;
};

export { ExternalRedirect };

ExternalRedirect.defaultProps = {
  replace: false,
  delay: 0,
};

ExternalRedirect.propTypes = {
  to: PropTypes.string.isRequired,
  replace: PropTypes.bool,
  delay: PropTypes.number,
};